/* Post-login dealer dashboard (spec #407).
 *
 * Reads everything through the Shopify App Proxy, which supplies the verified
 * logged_in_customer_id server-side - the storefront never asserts who the
 * dealer is, so a dealer cannot request another dealer's data by editing a
 * parameter.
 */
(function () {
  var app = document.getElementById('DealerDashboard');
  if (!app) return;

  var PROXY = app.dataset.proxyBase || '/apps/dealer';
  var STORE_KEY = 'oew-active-store';
  /* Which location's records the dealer pages show (Akshay 10-23): an explicit
   * choice ("all", or a store Shopify cannot switch this buyer to), else the
   * buyer's current Shopify location. The portal checks it against the login,
   * so it can only narrow what a login may see - never widen it. */
  var SCOPE_KEY = 'oew-dealer-scope';
  var scopeInfo = null;

  function explicitScope() {
    try { return localStorage.getItem(SCOPE_KEY) || ''; } catch (e) { return ''; }
  }

  function setScope(value) {
    try {
      if (value) localStorage.setItem(SCOPE_KEY, value); else localStorage.removeItem(SCOPE_KEY);
    } catch (e) {}
  }

  function scopeParam() {
    return explicitScope() || app.dataset.location || '';
  }

  var money = function (n) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(n) || 0);
  };

  /* Date-only values must not go through new Date('YYYY-MM-DD'), which parses
   * as UTC midnight and renders as the previous day in US timezones. */
  var day = function (iso) {
    if (!iso) return '';
    var p = String(iso).split('-');
    if (p.length !== 3) return iso;
    return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString('en-US',
      { month: 'short', day: 'numeric', year: 'numeric' });
  };

  var el = function (sel) { return app.querySelector(sel); };

  function get(path, params) {
    var p = new URLSearchParams(params || {});
    if (scopeParam()) p.set('location', scopeParam());
    var q = p.toString();
    return fetch(PROXY + path + (q ? '?' + q : ''), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); });
  }

  /* ---------------------------------------------------------------- context */

  var locations = [];
  var invoicePayEnabled = false;
  var invoicePayFeeRate = null;
  var openInvoiceRows = [];
  var invoicesSeq = 0;

  /* Shopify company locations for a B2B buyer (external id "addr-<NetSuite key>", the same
   * id the portal gives each location).
   * Checkout ships to the buyer's CURRENT company location, so that is the truth
   * for the active ship-to, and choosing one switches it through Shopify. */
  var shopifyLocations = (function () {
    var node = document.querySelector('[data-shopify-locations]');
    if (!node) return [];
    try { return JSON.parse(node.textContent) || []; } catch (e) { return []; }
  })();

  // The portal's location ids are already "addr-<key>"; accept a bare key too.
  function externalIdOf(store) {
    var id = String(store && store.id || '');
    return id.indexOf('addr-') === 0 ? id : 'addr-' + id;
  }

  function shopifyLocationFor(store) {
    if (!store) return null;
    var ext = externalIdOf(store);
    return shopifyLocations.filter(function (s) { return s.external_id === ext; })[0] || null;
  }

  function switchUrl(shopifyLoc) {
    // Come back to this page once Shopify has switched the location.
    try {
      var u = new URL(shopifyLoc.url, window.location.origin);
      u.searchParams.set('return_to', window.location.pathname + window.location.search);
      return u.pathname + u.search;
    } catch (e) { return shopifyLoc.url; }
  }

  function showingAll() {
    return !!(scopeInfo && scopeInfo.location === 'all' && scopeInfo.multiple && explicitScope() === 'all');
  }

  function activeStore() {
    var chosen = explicitScope();
    if (chosen && chosen !== 'all') {
      var picked = locations.filter(function (l) { return externalIdOf(l) === chosen; })[0];
      if (picked) return picked;
    }
    var current = shopifyLocations.filter(function (s) { return s.current; })[0];
    if (current) {
      var fromShopify = locations.filter(function (l) { return externalIdOf(l) === current.external_id; })[0];
      if (fromShopify) return fromShopify;
    }
    var stored;
    try { stored = localStorage.getItem(STORE_KEY); } catch (e) { stored = null; }
    var match = locations.filter(function (l) { return l.id === stored; })[0];
    return match || locations[0] || null;
  }

  function paintActiveStore() {
    if (showingAll()) {
      el('[data-active-name]').textContent = 'All locations';
      el('[data-active-address]').textContent = '';
      var all = el('[data-active-line]');
      if (all) { all.textContent = 'All locations'; all.title = ''; }
      return;
    }
    var store = activeStore();
    if (!store) return;
    el('[data-active-name]').textContent = store.name || '';
    el('[data-active-address]').textContent = store.summary || '';
    /* Change 7 (09-18): the active ship-to is always visible under the company,
     * so a switch between two same-named locations is confirmed at a glance. */
    var line = el('[data-active-line]');
    if (line) {
      var first = store.address || (store.summary || '').split(',')[0] || '';
      line.textContent = locations.length > 1 || first ? first + (store.city ? ', ' + store.city : '') : '';
      line.title = store.summary || '';
    }
  }

  function loadContext() {
    get('/dashboard/context').then(function (res) {
      if (!res.ok) {
        doneLoading('credit');
        el('[data-widget="credit"]').hidden = true;
        return;   // signed-out or unmapped dealer: leave chrome hidden
      }
      var d = res.body;

      el('[data-company-name]').textContent = d.company || '';
      el('[data-context-bar]').hidden = false;

      /* The rep is painted by dealer-rep.js (toolbar popover, account menu, PDP card). */
      locations = d.locations || [];
      scopeInfo = d.scope || null;
      /* A stale choice the portal ignored (no longer this login's) is dropped. */
      if (scopeInfo && explicitScope() && explicitScope() !== scopeInfo.location) setScope('');
      paintActiveStore();
      /* A single ship-to has nothing to choose between, so the spec hides the
       * Change button and leaves the location as static text. */
      el('[data-store-change]').hidden = locations.length < 2;

      var termsChip = document.querySelector('[data-context-terms]');
      if (termsChip && d.credit && d.credit.terms) { termsChip.textContent = d.credit.terms; termsChip.hidden = false; }
      /* Change 6: terms dealers read "My Quotes", card dealers "Recent Quotes". */
      el('[data-quotes-title]').textContent = d.credit && d.credit.terms ? 'My Quotes' : 'Recent Quotes';
      invoicePayEnabled = !!(d.invoice_pay && d.invoice_pay.enabled);
      if (d.invoice_pay && d.invoice_pay.fee_rate != null && d.invoice_pay.fee_rate !== '') {
        invoicePayFeeRate = Number(d.invoice_pay.fee_rate);
      }
      paintCredit(d.credit || {});
      paintPayChrome();
    }).catch(function () {
      doneLoading('credit');
      el('[data-widget="credit"]').hidden = true;
    });
  }

  function paintCredit(c) {
    doneLoading('credit');
    if (!c.configured) {
      el('[data-widget="credit"]').hidden = true;   // no limit on the record
      return;
    }

    /* A negative NetSuite balance is money on account (prepayment / credit memo).
     * It genuinely raises spending power, but "available $10,665 of a $10,000 limit"
     * reads as a bug — so Available Credit is capped at the limit and the credit is
     * shown on its own line. */
    var onAccount = c.balance < 0 ? -c.balance : 0;
    el('[data-credit-available]').textContent = money(Math.min(c.available, c.limit));
    el('[data-credit-limit]').textContent = money(c.limit);
    if (onAccount > 0) {
      el('[data-credit-onaccount]').textContent = money(onAccount);
      el('[data-onaccount-row]').hidden = false;
    }

    var termsRow = el('[data-terms-row]');
    if (c.terms) { el('[data-credit-terms]').textContent = c.terms; } else { termsRow.hidden = true; }

    /* Orders placed but not yet invoiced are subtracted from available credit,
     * so the dealer is shown why the two numbers do not simply reconcile. */
    if (c.unbilled > 0) {
      el('[data-credit-unbilled]').textContent = money(c.unbilled);
      el('[data-unbilled-row]').hidden = false;
    }

    if (c.overdue > 0) {
      el('[data-credit-overdue]').textContent = money(c.overdue);
      el('[data-overdue-days]').textContent = c.days_overdue > 0 ? ' by ' + c.days_overdue + ' days' : '';
      el('[data-overdue-row]').hidden = false;
    }

    var used = c.limit > 0 ? Math.min(Math.max(c.balance / c.limit, 0), 1) : 0;
    el('[data-credit-fill]').style.width = (used * 100).toFixed(1) + '%';
    el('[data-credit-bar]').setAttribute('aria-label',
      money(c.available) + ' available of ' + money(c.limit));

    el('[data-credit-body]').hidden = false;
    el('[data-widget="credit"]').hidden = false;
  }

  /* ----------------------------------------------------------- store picker */

  function renderStores(filter) {
    var list = el('[data-store-list]');
    var needle = (filter || '').trim().toLowerCase();
    var current = activeStore();

    var rows = locations.filter(function (l) {
      if (!needle) return true;
      return ((l.name || '') + ' ' + (l.summary || '')).toLowerCase().indexOf(needle) !== -1;
    });

    list.innerHTML = '';
    /* Company logins with several customer accounts can also see every
     * location's records at once. */
    if (scopeInfo && scopeInfo.kind === 'company' && scopeInfo.multiple && !needle) {
      list.appendChild(storeRow('All locations', 'Orders, quotes and invoices for every location',
        showingAll(), function () { setScope('all'); window.location.reload(); }));
    }
    if (!rows.length) {
      var empty = document.createElement('li');
      empty.className = 'dash-modal__empty';
      empty.textContent = 'No stores match that search.';
      list.appendChild(empty);
      return;
    }

    rows.forEach(function (l) {
      var isCurrent = !showingAll() && current && current.id === l.id;
      list.appendChild(storeRow(l.name || '', l.summary || '', isCurrent, function (btn) {
        try { localStorage.setItem(STORE_KEY, l.id); } catch (e) {}
        var target = shopifyLocationFor(l);
        if (target && target.url && !target.current) {
          /* Shopify switches the ship-to; the records follow its current location. */
          setScope('');
          btn.disabled = true;
          btn.textContent = 'Switching…';
          window.location.href = switchUrl(target);
          return;
        }
        /* Already the Shopify location, or one Shopify cannot switch this buyer
         * to: show that location's records without changing the ship-to. */
        setScope(target && target.current ? '' : externalIdOf(l));
        window.location.reload();
      }));
    });
  }

  function storeRow(title, summary, isCurrent, onChoose) {
    var li = document.createElement('li');
    li.className = 'dash-modal__row';

    var info = document.createElement('div');
    var name = document.createElement('span');
    name.className = 'dash-modal__row-name';
    name.textContent = title;
    var addr = document.createElement('span');
    addr.className = 'dash-modal__row-addr';
    addr.textContent = summary;
    info.appendChild(name);
    info.appendChild(addr);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dash-modal__choose';
    btn.textContent = isCurrent ? 'Current' : 'Choose';
    btn.disabled = !!isCurrent;
    btn.addEventListener('click', function () { onChoose(btn); });

    li.appendChild(info);
    li.appendChild(btn);
    return li;
  }

  function openModal() {
    renderStores('');
    el('[data-store-search]').value = '';
    el('[data-store-modal]').hidden = false;
    el('[data-store-search]').focus();
  }

  function closeModal() { el('[data-store-modal]').hidden = true; }

  el('[data-store-change]').addEventListener('click', openModal);
  Array.prototype.forEach.call(app.querySelectorAll('[data-store-close]'), function (b) {
    b.addEventListener('click', closeModal);
  });
  el('[data-store-search]').addEventListener('input', function (e) { renderStores(e.target.value); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !el('[data-store-modal]').hidden) closeModal();
  });

  var companyToggle = el('[data-company-toggle]');
  var companyBox = el('[data-company-summary]');

  function setCompanyOpen(open) {
    companyBox.hidden = !open;
    companyToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  companyToggle.addEventListener('click', function () { setCompanyOpen(companyBox.hidden); });

  /* DASH-06 (09-18): the panel closes on any click outside it, and on Escape. */
  document.addEventListener('click', function (e) {
    if (!companyBox.hidden && !companyBox.contains(e.target) && !companyToggle.contains(e.target)) setCompanyOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !companyBox.hidden) setCompanyOpen(false);
  });

  /* -------------------------------------------------------------- tracking */

  function message(host, text) {
    host.hidden = false;
    host.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'dash-widget__message';
    p.textContent = text;
    host.appendChild(p);
  }

  function resetLink(host, label, onReset) {
    var a = document.createElement('button');
    a.type = 'button';
    a.className = 'dash-widget__reset';
    a.textContent = label;
    a.addEventListener('click', onReset);
    host.appendChild(a);
  }

  /* Tracking and Invoice Lookup are stacked (not tabs, per Derek), so the lower panel's
   * results can land below the fold: bring the panel into view when a search runs. */
  function revealWidget(host) {
    var w = host && host.closest('.dash-widget');
    if (w && w.scrollIntoView) setTimeout(function () { w.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 50);
  }

  el('[data-tracking-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var host = el('[data-tracking-results]');
    var q = el('#DashTrackingQuery').value.trim();
    if (!q) return;
    revealWidget(host);

    message(host, 'Searching…');

    get('/dashboard/tracking', { q: q }).then(function (res) {
      if (!res.ok) { message(host, 'Something went wrong. Please try again.'); return; }
      var d = res.body;

      if (d.status === 'not_found') {
        message(host, 'No order found for this number. Please verify and try again.');
        return;
      }
      if (d.status === 'no_tracking') {
        message(host, 'Order not yet fulfilled. Please check your Orders page for details.');
        return;
      }

      host.hidden = false;
      host.innerHTML = '';

      var head = document.createElement('p');
      head.className = 'dash-widget__resulthead';
      head.textContent = 'Order ' + d.order.number + (d.order.po ? ' · PO ' + d.order.po : '');
      host.appendChild(head);

      d.shipments.forEach(function (s) {
        var row = document.createElement('div');
        row.className = 'dash-track';

        var top = document.createElement('div');
        top.className = 'dash-track__top';
        if (s.url) {
          var a = document.createElement('a');
          a.href = s.url;
          a.target = '_blank';
          a.rel = 'noopener';
          a.className = 'dash-track__number';
          a.textContent = s.tracking;
          top.appendChild(a);
        } else {
          var span = document.createElement('span');
          span.className = 'dash-track__number';
          span.textContent = s.tracking;
          top.appendChild(span);
        }
        if (s.carrier) {
          var badge = document.createElement('span');
          badge.className = 'dash-track__carrier';
          badge.textContent = s.carrier;
          top.appendChild(badge);
        }
        row.appendChild(top);

        if (s.shipped) {
          var when = document.createElement('span');
          when.className = 'dash-track__date';
          when.textContent = 'Shipped ' + day(s.shipped);
          row.appendChild(when);
        }
        host.appendChild(row);
      });

      resetLink(host, 'Track Another Shipment', function () {
        el('#DashTrackingQuery').value = '';
        host.hidden = true;
        el('#DashTrackingQuery').focus();
      });
    });
  });

  /* -------------------------------------------------------- invoice lookup */

  var LOOKUP_MAX = 10;
  var INVOICES_URL = app.dataset.invoicesUrl || '/pages/invoices';

  el('[data-invoice-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var host = el('[data-invoice-results]');
    revealWidget(host);
    var params = {
      q: el('#DashInvoiceQuery').value.trim(),
      from: el('#DashInvoiceFrom').value,
      to: el('#DashInvoiceTo').value
    };
    if (!params.q && !params.from && !params.to) {
      message(host, 'Enter an order number, PO, or a date range.');
      return;
    }

    message(host, 'Searching…');

    get('/invoices/lookup', params).then(function (res) {
      if (!res.ok) { message(host, 'Something went wrong. Please try again.'); return; }
      var rows = res.body.invoices || [];
      if (!rows.length) { message(host, 'No invoices found for that search.'); return; }

      host.hidden = false;
      host.innerHTML = '';

      /* Change 8 (09-18): at most 10 results here, 5 visible and the rest scrolling inside
       * the list; a longer result set continues on the Invoices page with the same filter. */
      var list = document.createElement('div');
      list.className = 'dash-invoice-list';
      host.appendChild(list);

      rows.slice(0, LOOKUP_MAX).forEach(function (inv) {
        var row = document.createElement('div');
        row.className = 'dash-invoice';

        var top = document.createElement('div');
        top.className = 'dash-invoice__top';

        var link = document.createElement('a');
        link.className = 'dash-invoice__number';
        link.href = PROXY + '/invoices/' + encodeURIComponent(inv.id) + '/pdf';
        link.textContent = 'Invoice ' + inv.number;
        top.appendChild(link);

        var status = document.createElement('span');
        status.className = 'dash-invoice__status' + (inv.open ? ' is-open' : '');
        status.textContent = (inv.status || '').toUpperCase();
        top.appendChild(status);
        row.appendChild(top);

        var total = document.createElement('span');
        total.className = 'dash-invoice__total';
        total.textContent = money(inv.total);
        row.appendChild(total);

        if (inv.order_number) {
          var so = document.createElement('span');
          so.className = 'dash-invoice__order';
          so.textContent = 'Sales Order ' + inv.order_number;
          row.appendChild(so);
        }
        list.appendChild(row);
      });

      if (rows.length > LOOKUP_MAX) {
        var more = document.createElement('p');
        more.className = 'dash-invoice-more';
        more.textContent = 'Showing ' + LOOKUP_MAX + ' of ' + rows.length + ' invoices.';
        host.appendChild(more);

        var all = document.createElement('a');
        all.className = 'dash-widget__submit dash-invoice-all';
        all.href = INVOICES_URL + '?' + new URLSearchParams(
          Object.keys(params).reduce(function (o, k) { if (params[k]) o[k] = params[k]; return o; }, {})
        ).toString();
        all.textContent = 'View All Invoices';
        host.appendChild(all);
      }

      resetLink(host, 'Search Again', function () {
        el('#DashInvoiceQuery').value = '';
        el('#DashInvoiceFrom').value = '';
        el('#DashInvoiceTo').value = '';
        host.hidden = true;
        el('#DashInvoiceQuery').focus();
      });
    });
  });

  /* -------------------------------------------- transactional cards (hero) */

  var DETAIL_URL = app.dataset.detailUrl || '/pages/order-detail';

  /* Statuses where the dealer is still waiting on something. Mirrors
   * DealerOrderService::OPEN_STATUSES, which drives the priority sort. */
  var OPEN_CODES = ['A', 'B', 'D', 'E', 'F'];

  /* NetSuite sales-order status codes -> a coarse visual state. Anything in
   * flight is amber, terminal-good is green, cancelled/closed is grey. */
  function statusTone(code) {
    if (code === 'C' || code === 'H') return 'muted';
    if (code === 'G') return 'good';
    return 'progress';
  }

  function cell(tr, cls, node) {
    var td = document.createElement('td');
    if (cls) td.className = cls;
    if (typeof node === 'string') td.textContent = node; else if (node) td.appendChild(node);
    tr.appendChild(td);
    return td;
  }

  function viewLink(href, label) {
    var a = document.createElement('a');
    a.className = 'dash-table__view';
    a.href = href;
    a.textContent = label || 'View';
    return a;
  }

  /* Tracking cell for the orders table.
   *
   * Post-purchase, "where is it" beats "what did it cost" (08-13 call), so
   * this sits where the order total used to. The number is shortened to keep
   * the column narrow; the full set is in the tooltip and on the order detail.
   */
  function trackingCell(tr, o, href) {
    var ships = o.shipments || [];

    if (!ships.length) {
      /* Absent tracking means two different things, and saying the wrong one
       * misleads: an order still in flight has not shipped, but a billed or
       * closed order shipped by a means that records no number (freight,
       * will-call). Only claim the former when the status supports it. */
      cell(tr, 'dash-table__muted',
        OPEN_CODES.indexOf((o.status || {}).code) !== -1 ? 'Not shipped yet' : 'No tracking');
      return;
    }

    var wrap = document.createElement('span');
    wrap.className = 'dash-ship';

    /* Change 6 (09-18): up to two tracking numbers in the cell; any beyond that
     * live on the order detail behind "+N more". */
    ships.slice(0, 2).forEach(function (s) {
      var line = document.createElement('span');
      line.className = 'dash-ship__line';
      var node = document.createElement(s.url ? 'a' : 'span');
      node.className = 'dash-ship__number';
      node.textContent = s.tracking.length > 12 ? s.tracking.slice(0, 12) + '…' : s.tracking;
      node.title = s.tracking;
      if (s.url) {
        node.href = s.url;
        node.target = '_blank';
        node.rel = 'noopener';
      }
      line.appendChild(node);
      if (s.carrier) {
        var badge = document.createElement('span');
        badge.className = 'dash-ship__carrier';
        badge.textContent = s.carrier;
        line.appendChild(badge);
      }
      wrap.appendChild(line);
    });

    if (ships.length > 2) {
      var more = document.createElement('a');
      more.className = 'dash-ship__more';
      more.href = href;
      more.textContent = '+' + (ships.length - 2) + ' more';
      wrap.appendChild(more);
    }

    cell(tr, null, wrap);
  }

  /* Each card clears its own spinner the moment its request settles. */
  function doneLoading(tag) {
    var box = el('[data-loading="' + tag + '"]');
    if (box) box.hidden = true;
  }

  var QUOTES_URL = '/pages/my-quotes';

  function renderQuoteRows(rows) {
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var tbody = el('[data-open-quotes]');

    rows.forEach(function (q) {
      var tr = document.createElement('tr');

      cell(tr, null, viewLink(QUOTES_URL, '#' + q.quote_number));
      cell(tr, 'dash-table__muted', day(q.date));

      var isOpen = q.status.code === 'A';
      var st = document.createElement('span');
      st.className = 'dash-status dash-status--' +
        (q.status.code === 'B' ? 'good' : isOpen ? 'progress' : 'muted');
      st.textContent = q.status.code === 'B' ? 'Converted' : q.status.label;
      cell(tr, null, st);

      /* Countdown only while the quote is still open - urgency is the point. */
      if (isOpen && q.expires) {
        var p = q.expires.split('-');
        var due = new Date(+p[0], +p[1] - 1, +p[2]);
        var days = Math.round((due - today) / 86400000);
        var span = document.createElement('span');
        span.className = days < 0 ? 'dash-due dash-due--past' : 'dash-due';
        span.textContent = day(q.expires) + (days >= 0
          ? ' \u00b7 ' + (days === 0 ? 'today' : days + (days === 1 ? ' day' : ' days') + ' left')
          : ' \u00b7 expired');
        cell(tr, null, span);
      } else {
        cell(tr, 'dash-table__muted', '\u2014');
      }

      cell(tr, 'dash-table__num dash-table__strong', money(q.total));
      cell(tr, 'dash-table__act', viewLink(QUOTES_URL, 'View'));
      tbody.appendChild(tr);
    });

    el('[data-quotes-table]').hidden = false;
  }

  function loadOpenQuotes() {
    /* priority: within the open quotes, the one expiring soonest leads - it
     * is the one the dealer loses first (08-13 call). */
    get('/quotes', { status: 'open', per_page: 10, priority: '1' }).then(function (res) {
      var rows = (res.ok && res.body.quotes) || [];
      if (rows.length) { doneLoading('quotes'); renderQuoteRows(rows); return; }

      /* Nothing open: recent quote history keeps the card informative. */
      get('/quotes', { per_page: 10, priority: '1' }).then(function (all) {
        var recent = (all.ok && all.body.quotes) || [];
        doneLoading('quotes');
        if (recent.length) {
          renderQuoteRows(recent);
        } else {
          el('[data-quotes-empty]').hidden = false;
        }
      }).catch(function () { doneLoading('quotes'); el('[data-quotes-empty]').hidden = false; });
    }).catch(function () { doneLoading('quotes'); el('[data-quotes-empty]').hidden = false; });
  }

  function loadRecentOrders() {
    /* priority: orders the dealer is still waiting on lead, recent history
     * backfills the rest (08-13 call). */
    get('/orders', { per_page: 10, range: 'all', priority: '1' }).then(function (res) {
      var rows = (res.ok && res.body.orders) || [];
      doneLoading('orders');
      if (!rows.length) {
        el('[data-recent-orders-card]').hidden = true;   // nothing to show yet
        return;
      }

      var tbody = el('[data-recent-orders]');
      rows.forEach(function (o) {
        var tr = document.createElement('tr');
        var href = DETAIL_URL + '?order=' + encodeURIComponent(o.id);

        cell(tr, null, viewLink(href, '#' + o.order_number));
        cell(tr, 'dash-table__muted', day((o.created || '').slice(0, 10)));

        var status = document.createElement('span');
        status.className = 'dash-status dash-status--' + statusTone((o.status || {}).code);
        status.textContent = (o.status || {}).label || '';
        cell(tr, null, status);

        cell(tr, 'dash-table__muted', o.po || '\u2014');
        /* The shipment-count chip that used to hang off the status is gone:
         * the tracking column states it outright. */
        trackingCell(tr, o, href);
        cell(tr, 'dash-table__num dash-table__strong', money(o.total));
        cell(tr, 'dash-table__act', viewLink(href));
        tbody.appendChild(tr);
      });
      el('[data-orders-table]').hidden = false;
    }).catch(function () {
      doneLoading('orders');
      el('[data-recent-orders-card]').hidden = true;
    });
  }

  function reloadOpenInvoices() {
    var loading = el('[data-loading="invoices"]');
    if (loading) loading.hidden = false;
    var table = el('[data-invoices-table]');
    if (table) table.hidden = true;
    var clearMsg = el('[data-invoices-clear]');
    if (clearMsg) clearMsg.hidden = true;
    var sum = el('[data-open-invoices-sum]');
    if (sum) sum.textContent = '';
    var header = el('[data-pay-invoices]');
    if (header) header.hidden = true;
    loadOpenInvoices();
  }

  function loadOpenInvoices() {
    var seq = ++invoicesSeq;
    get('/invoices/lookup', { open: '1' }).then(function (res) {
      if (seq !== invoicesSeq) return;
      doneLoading('invoices');
      var tbody = el('[data-open-invoices]');
      if (tbody) tbody.innerHTML = '';
      openInvoiceRows = [];
      if (!res.ok) {
        el('[data-open-invoices-card]').hidden = true;
        paintPayChrome();
        return;
      }
      var rows = res.body.invoices || [];
      openInvoiceRows = rows;
      if (!rows.length) {
        /* Change 6: the right half of row 2 stays in place with a placeholder. */
        el('[data-invoices-clear]').hidden = false;
        el('[data-all-invoices]').hidden = false;
        el('[data-invoices-table]').hidden = true;
        paintPayChrome();
        return;
      }

      var today = new Date(); today.setHours(0, 0, 0, 0);
      var total = 0;
      var shown = rows.slice(0, 10);   // max 10 rows per panel (Derek, 08-20); the rest is in Invoice Lookup
      rows.forEach(function (inv) { total += Number(inv.balance) || 0; });

      shown.forEach(function (inv) {
        var tr = document.createElement('tr');
        tr.setAttribute('data-invoice-id', String(inv.id));

        cell(tr, null, viewLink(PROXY + '/invoices/' + encodeURIComponent(inv.id) + '/pdf', '#' + inv.number));
        cell(tr, 'dash-table__muted', inv.order_number ? '#' + inv.order_number : '\u2014');

        var dueTd;
        if (inv.due_date) {
          var p = inv.due_date.split('-');
          var due = new Date(+p[0], +p[1] - 1, +p[2]);
          var overdue = due < today;
          var span = document.createElement('span');
          span.className = overdue ? 'dash-due dash-due--past' : 'dash-due';
          span.textContent = day(inv.due_date) + (overdue
            ? ' \u00b7 ' + Math.round((today - due) / 86400000) + ' days past due' : '');
          dueTd = cell(tr, null, span);
        } else {
          dueTd = cell(tr, 'dash-table__muted', '\u2014');
        }

        cell(tr, 'dash-table__num dash-table__strong', money(inv.balance));
        var acts = document.createElement('span');
        acts.className = 'dash-table__acts';
        acts.appendChild(viewLink(PROXY + '/invoices/' + encodeURIComponent(inv.id) + '/pdf', 'PDF'));
        cell(tr, 'dash-table__act', acts);
        tbody.appendChild(tr);
      });

      el('[data-open-invoices-sum]').textContent = money(total) + ' outstanding' + (rows.length > shown.length ? ' \u00b7 showing ' + shown.length + ' of ' + rows.length : '');
      /* Change 2 (09-18): straight to the full list from the outstanding total. */
      el('[data-all-invoices]').hidden = false;
      el('[data-invoices-table]').hidden = false;
      paintPayChrome();
    }).catch(function () {
      if (seq !== invoicesSeq) return;
      doneLoading('invoices');
      openInvoiceRows = [];
      el('[data-open-invoices-card]').hidden = true;
      paintPayChrome();
    });
  }

  /* ------------------------------------------------------- pay invoices */

  /* Amounts come from the portal quote. The browser never prices the charge.
     One idempotency key per modal open. A decline or a validation error
     mints a new key. gateway_unknown, payment_unconfirmed, and key_used
     do not: those results offer only Close, and the dealer opens the
     dialog again to start over. */
  var PAY_GENERIC = 'Something went wrong. Please try again.';
  var PAY_UNCONFIRMED = "We couldn't confirm this payment \u2014 please contact AR before trying again";
  var PAY_EARLIER = "We couldn't confirm an earlier payment for one of these invoices \u2014 please contact AR before trying again";
  var PAY_KEY_USED = 'This payment was already submitted. Please contact AR before trying again.';
  var PAY_VALIDATION = {
    bad_request: 1,
    invoice_not_open: 1,
    token_not_owned: 1,
    total_mismatch: 1,
    duplicate_key: 1
  };

  /* Same codes as the portal's StateCodes: 50 states, then DC, PR, GU, VI,
     AS, MP, AA, AE, AP, and the Canadian provinces. Values are codes only. */
  var STATE_CODES = {
    US: [
      ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
      ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'],
      ['FL', 'Florida'], ['GA', 'Georgia'], ['HI', 'Hawaii'], ['ID', 'Idaho'],
      ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'], ['KS', 'Kansas'],
      ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'], ['MD', 'Maryland'],
      ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'],
      ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'], ['NV', 'Nevada'],
      ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'], ['NY', 'New York'],
      ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'],
      ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'], ['SC', 'South Carolina'],
      ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'], ['UT', 'Utah'],
      ['VT', 'Vermont'], ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'],
      ['WI', 'Wisconsin'], ['WY', 'Wyoming'],
      ['DC', 'District of Columbia'], ['PR', 'Puerto Rico'], ['GU', 'Guam'],
      ['VI', 'U.S. Virgin Islands'], ['AS', 'American Samoa'], ['MP', 'Northern Mariana Islands'],
      ['AA', 'Armed Forces Americas'], ['AE', 'Armed Forces Europe'], ['AP', 'Armed Forces Pacific']
    ],
    CA: [
      ['AB', 'Alberta'], ['BC', 'British Columbia'], ['MB', 'Manitoba'], ['NB', 'New Brunswick'],
      ['NL', 'Newfoundland and Labrador'], ['NS', 'Nova Scotia'], ['NT', 'Northwest Territories'],
      ['NU', 'Nunavut'], ['ON', 'Ontario'], ['PE', 'Prince Edward Island'], ['QC', 'Quebec'],
      ['SK', 'Saskatchewan'], ['YT', 'Yukon']
    ]
  };
  var BILLING_FIELDS = ['address1', 'city', 'state', 'zip'];
  var AVS_FIELDS = ['address1', 'zip'];
  var BILLING_MSG = {
    address1: 'Enter the billing street address and city.',
    address2: 'Enter the billing street address and city.',
    city: 'Enter the billing street address and city.',
    state: 'Choose the billing state.',
    zip: 'Enter a valid billing ZIP code.',
    country: 'Choose the billing state.'
  };

  var payRoot = null;
  var paySession = 0;
  var payKey = null;
  var payQuote = null;
  var payCards = [];
  var payBusy = false;
  var cardBusy = false;
  var cardBlocked = false;
  var cardBlockMessage = '';
  var cardCooldownUntil = 0;
  var cardCooldownTimer = null;
  var cardCooldownMessage = '';
  var payAttempted = false;
  var paySucceeded = false;
  var payReloadOnClose = false;
  var stickyPayError = false;
  var quoteTimer = null;
  var quoteSeq = 0;
  var quoteBusy = false;
  var payReturnFocus = null;
  var payAddresses = [];
  var billingDefault = null;
  var billingNeedsState = false;
  var billingAvsOpen = false;
  var addressesLoaded = false;
  var addressesLoading = false;

  function payUiOn() {
    return invoicePayEnabled === true && app.dataset.showPayButton !== 'false';
  }

  function payEl(sel) {
    if (!payRoot) return null;
    if (payRoot.matches && payRoot.matches(sel)) return payRoot;
    return payRoot.querySelector(sel);
  }

  function payModalOpen() {
    return !!(payRoot && !payRoot.hidden);
  }

  function mintKey() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
    else for (var i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    var hex = [];
    for (var j = 0; j < 16; j++) hex.push((bytes[j] + 0x100).toString(16).slice(1));
    return hex.slice(0, 4).join('') + '-' + hex.slice(4, 6).join('') + '-' + hex.slice(6, 8).join('') + '-' + hex.slice(8, 10).join('') + '-' + hex.slice(10, 16).join('');
  }

  function amountString(n) {
    var x = Number(n);
    if (!isFinite(x)) return '0.00';
    return (Math.round((x + Number.EPSILON) * 100) / 100).toFixed(2);
  }

  function feePhrase(rate) {
    var n = Number(rate);
    if (!isFinite(n)) return 'Card convenience fee';
    var pct = Math.round(n * 10000) / 100;
    var text = Math.abs(pct - Math.round(pct)) < 0.001 ? String(Math.round(pct)) : String(pct);
    return 'Card convenience fee (' + text + '%)';
  }

  /* Portal errors use `error`. Older bodies used `code`. HTTP status is not the discriminator. */
  function payErrorCode(body) {
    if (!body || typeof body !== 'object') return '';
    if (typeof body.error === 'string' && body.error) return body.error;
    if (typeof body.code === 'string' && body.code) return body.code;
    return '';
  }

  function payMessage(body, fallback) {
    if (body && typeof body.message === 'string' && body.message) return body.message;
    return fallback;
  }

  function readJsonResponse(r) {
    return r.text().then(function (text) {
      var body = {};
      if (text) {
        try { body = JSON.parse(text); } catch (e) { body = {}; }
      }
      return {
        ok: r.ok,
        status: r.status,
        body: body || {},
        retryAfter: r.headers && r.headers.get ? r.headers.get('Retry-After') : null
      };
    });
  }

  function proxyFetch(path, options) {
    return fetch(PROXY + path, options).then(readJsonResponse);
  }

  function clearChildren(node) {
    if (!node) return;
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function showPayError(text, sticky) {
    stickyPayError = !!sticky;
    var node = payEl('[data-pay-error]');
    if (!node) return;
    node.textContent = text;
    node.hidden = false;
  }

  function clearPayError() {
    stickyPayError = false;
    var node = payEl('[data-pay-error]');
    if (!node) return;
    node.textContent = '';
    node.hidden = true;
  }

  function payRowButton(inv) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dash-table__pay';
    btn.setAttribute('data-pay-row', '');
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-controls', 'DashPayDialog');
    btn.textContent = 'Pay';
    btn.setAttribute('aria-label', 'Pay invoice ' + (inv.number || inv.id));
    btn.addEventListener('click', function () { openPayModal(inv.id); });
    return btn;
  }

  /* Mobile QA 2026-10-14 (M19): My Invoices links "Pay" to /pages/dashboard?pay=<id>
     (or ?pay=all). Open the dialog once the open invoices are known, then drop the param. */
  var payDeepLinkDone = false;
  function openPayFromLink() {
    if (payDeepLinkDone || !payUiOn() || !payableRows().length) return;
    var want = null;
    try { want = new URLSearchParams(window.location.search).get('pay'); } catch (e) { return; }
    if (!want) return;
    payDeepLinkDone = true;
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('pay');
      window.history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) {}
    openPayModal(want === 'all' ? null : want);
  }

  /* Pay Invoices settles the company account's own invoices; a child
   * location's invoice is listed but has no Pay button (portal sets payable). */
  function payableRows() {
    return openInvoiceRows.filter(function (inv) { return inv.payable !== false; });
  }

  function paintPayChrome() {
    var on = payUiOn();
    setTimeout(openPayFromLink, 0);
    var header = el('[data-pay-invoices]');
    if (header) header.hidden = !(on && payableRows().length > 0);
    var tbody = el('[data-open-invoices]');
    if (!tbody) return;
    Array.prototype.forEach.call(tbody.querySelectorAll('tr'), function (tr) {
      var existing = tr.querySelector('[data-pay-row]');
      if (!on) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      if (existing) return;
      var id = tr.getAttribute('data-invoice-id');
      var acts = tr.querySelector('.dash-table__acts');
      if (!id || !acts || !/^\d+$/.test(id)) return;
      var inv = null;
      for (var i = 0; i < openInvoiceRows.length; i++) {
        if (String(openInvoiceRows[i].id) === id) { inv = openInvoiceRows[i]; break; }
      }
      if (inv && inv.payable === false) return;
      acts.insertBefore(payRowButton(inv || { id: id, number: id }), acts.firstChild);
    });
  }

  function selectedIds() {
    var list = payEl('[data-pay-invoices-list]');
    if (!list) return [];
    return Array.prototype.map.call(list.querySelectorAll('input[type="checkbox"]:checked'), function (input) {
      return input.value;
    });
  }

  function sameIds(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (String(a[i]) !== String(b[i])) return false;
    return true;
  }

  function selectedToken() {
    var input = payEl('[data-pay-cards] input[type="radio"]:checked');
    return input ? input.value : '';
  }

  function syncSelectAll() {
    var list = payEl('[data-pay-invoices-list]');
    var all = payEl('[data-pay-select-all]');
    if (!list || !all) return;
    var boxes = list.querySelectorAll('input[type="checkbox"]');
    var checked = list.querySelectorAll('input[type="checkbox"]:checked');
    all.checked = boxes.length > 0 && checked.length === boxes.length;
    all.indeterminate = checked.length > 0 && checked.length < boxes.length;
  }

  function setQuoteStatus(on) {
    var node = payEl('[data-pay-quote-status]');
    if (node) node.hidden = !on;
    var summary = payEl('[data-pay-summary]');
    if (summary) summary.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function paintSummary(q) {
    var sub = payEl('[data-pay-subtotal]');
    var fee = payEl('[data-pay-fee]');
    var feeLabel = payEl('[data-pay-fee-label]');
    var total = payEl('[data-pay-total]');
    var rate = q && q.fee_rate != null ? q.fee_rate : invoicePayFeeRate;
    if (feeLabel) feeLabel.textContent = feePhrase(rate);
    if (!q) {
      if (sub) sub.textContent = '\u2014';
      if (fee) fee.textContent = '\u2014';
      if (total) total.textContent = '\u2014';
      return;
    }
    if (sub) sub.textContent = money(q.invoice_total);
    if (fee) fee.textContent = money(q.fee_amount);
    if (total) total.textContent = money(q.total);
  }

  function hidePayCta() {
    var submit = payEl('[data-pay-submit]');
    if (submit) submit.hidden = true;
  }

  function showPayCta() {
    var submit = payEl('[data-pay-submit]');
    if (submit) submit.hidden = false;
  }

  function syncPayButton() {
    var btn = payEl('[data-pay-submit]');
    if (!btn || btn.hidden) return;
    var ids = selectedIds();
    var token = selectedToken();
    var quoteReady = !!(payQuote && sameIds(payQuote._ids, ids));
    var ready = !payBusy && !quoteBusy && payCards.length > 0 && ids.length > 0 && ids.length <= 50 && quoteReady && !!token && billingAddressReady();
    btn.disabled = !ready;
    btn.setAttribute('aria-busy', payBusy ? 'true' : 'false');
    var spinner = payEl('[data-pay-spinner]');
    if (spinner) spinner.hidden = !payBusy;
    var label = payEl('[data-pay-submit-label]');
    if (label && !payBusy) label.textContent = quoteReady ? 'Pay ' + money(payQuote.total) : 'Pay';
  }

  function renderInvoices(preselectId) {
    var list = payEl('[data-pay-invoices-list]');
    if (!list) return;
    clearChildren(list);
    var wantOne = preselectId != null && preselectId !== '';
    payableRows().forEach(function (inv) {
      if (!/^\d+$/.test(String(inv.id))) return;
      var li = document.createElement('li');
      li.className = 'dash-pay__inv';
      var label = document.createElement('label');
      label.className = 'dash-pay__inv-label';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.value = String(inv.id);
      input.checked = wantOne ? String(inv.id) === String(preselectId) : true;
      var text = document.createElement('span');
      text.className = 'dash-pay__inv-text';
      var num = document.createElement('span');
      num.className = 'dash-pay__inv-num';
      num.textContent = '#' + (inv.number || inv.id);
      text.appendChild(num);
      if (inv.due_date) {
        var due = document.createElement('span');
        due.className = 'dash-pay__inv-due';
        due.textContent = 'Due ' + day(inv.due_date);
        text.appendChild(due);
      }
      var bal = document.createElement('span');
      bal.className = 'dash-pay__inv-bal';
      bal.textContent = money(inv.balance);
      label.appendChild(input);
      label.appendChild(text);
      label.appendChild(bal);
      li.appendChild(label);
      list.appendChild(li);
    });
    syncSelectAll();
  }

  function cardExpiryText(card) {
    if (!card) return '';
    if (card.expires) return String(card.expires);
    var month = Number(card.exp_month);
    var year = Number(card.exp_year);
    if (!month || !year) return '';
    var mm = month < 10 ? '0' + month : String(month);
    return mm + '/' + String(year).slice(-2);
  }

  function cardLine(card) {
    var brand = card.brand ? String(card.brand) : 'Card';
    var last4 = card.last4 ? String(card.last4) : '';
    var text = brand + ' \u2022\u2022\u2022\u2022 ' + last4;
    var exp = cardExpiryText(card);
    if (exp) text += ' \u00b7 exp ' + exp;
    return text;
  }

  function setAddOpenPrimary(on) {
    var addBtn = payEl('[data-pay-add-open]');
    if (!addBtn) return;
    addBtn.classList.toggle('dash-pay__add-open--primary', !!on);
  }

  function setCardsEmpty(on) {
    var empty = payEl('[data-pay-cards-empty]');
    if (empty) empty.hidden = !on;
  }

  function renderCards(cards, preferToken) {
    payCards = cards || [];
    var host = payEl('[data-pay-cards]');
    clearChildren(host);
    var addBtn = payEl('[data-pay-add-open]');
    if (addBtn) addBtn.hidden = false;
    if (!payCards.length) {
      setCardsEmpty(true);
      setAddOpenPrimary(true);
      showPayCta();
      return;
    }
    setCardsEmpty(false);
    setAddOpenPrimary(false);
    showPayCta();
    var chosen = preferToken ? String(preferToken) : '';
    var have = false;
    if (chosen) {
      for (var i = 0; i < payCards.length; i++) {
        if (String(payCards[i].token_id) === chosen) { have = true; break; }
      }
    }
    if (!have) {
      chosen = '';
      payCards.forEach(function (card) {
        if (!chosen && card.is_default) chosen = String(card.token_id);
      });
      if (!chosen) chosen = String(payCards[0].token_id);
    }
    payCards.forEach(function (card) {
      var id = String(card.token_id);
      var label = document.createElement('label');
      label.className = 'dash-pay__card';
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'pay-card';
      input.value = id;
      input.checked = id === chosen;
      var span = document.createElement('span');
      span.textContent = cardLine(card);
      label.appendChild(input);
      label.appendChild(span);
      host.appendChild(label);
    });
  }

  function setCardsLoading() {
    payCards = [];
    clearChildren(payEl('[data-pay-cards]'));
    setCardsEmpty(false);
    setAddOpenPrimary(false);
    var status = payEl('[data-pay-cards-status]');
    if (status) status.hidden = false;
    var addBtn = payEl('[data-pay-add-open]');
    if (addBtn) addBtn.hidden = true;
    showPayCta();
    syncPayButton();
  }

  function countryOf(addr) {
    return addr && String(addr.country || '').toUpperCase() === 'CA' ? 'CA' : 'US';
  }

  function stateIsValid(code, country) {
    var list = STATE_CODES[country] || [];
    var want = String(code || '').toUpperCase();
    if (!want) return false;
    for (var i = 0; i < list.length; i++) if (list[i][0] === want) return true;
    return false;
  }

  function normalizeZip(zip, country) {
    var raw = String(zip || '').trim();
    if (country === 'CA') {
      var compact = raw.toUpperCase().replace(/\s+/g, '');
      if (compact.length === 6) return compact.slice(0, 3) + ' ' + compact.slice(3);
      return raw.toUpperCase();
    }
    return raw;
  }

  function zipIsValid(zip, country) {
    if (country === 'CA') return /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(normalizeZip(zip, 'CA'));
    return /^\d{5}(-\d{4})?$/.test(String(zip || '').trim());
  }

  function addressProblems(addr) {
    var problems = {};
    var country = countryOf(addr);
    var street = String(addr && addr.address1 || '').trim();
    var city = String(addr && addr.city || '').trim();
    var line2 = String(addr && addr.address2 || '').trim();
    var state = String(addr && addr.state || '').toUpperCase();
    if (!street || street.length > 100) problems.address1 = BILLING_MSG.address1;
    if (!city || city.length > 60) problems.city = BILLING_MSG.city;
    if (line2.length > 100) problems.address2 = BILLING_MSG.address2;
    if (!stateIsValid(state, country)) problems.state = BILLING_MSG.state;
    if (!zipIsValid(addr && addr.zip, country)) problems.zip = BILLING_MSG.zip;
    return problems;
  }

  function addressIsValid(addr) {
    var problems = addressProblems(addr);
    var keys = Object.keys(problems);
    return keys.length === 0;
  }

  function addressLine(addr) {
    if (!addr) return '';
    var street = [String(addr.address1 || '').trim(), String(addr.address2 || '').trim()].filter(Boolean).join(', ');
    var city = String(addr.city || '').trim();
    var region = [String(addr.state || '').trim(), String(addr.zip || '').trim()].filter(Boolean).join(' ');
    var place = city && region ? city + ', ' + region : (city || region);
    return [street, place].filter(Boolean).join(', ');
  }

  function fillStateSelect(select, country, selected) {
    if (!select) return;
    var list = STATE_CODES[country] || STATE_CODES.US;
    var current = selected != null ? String(selected).toUpperCase() : String(select.value || '').toUpperCase();
    clearChildren(select);
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = country === 'CA' ? 'Province' : 'State';
    select.appendChild(placeholder);
    var found = false;
    list.forEach(function (pair) {
      var opt = document.createElement('option');
      opt.value = pair[0];
      opt.textContent = pair[0] + ' \u2014 ' + pair[1];
      if (pair[0] === current) {
        opt.selected = true;
        found = true;
      }
      select.appendChild(opt);
    });
    if (!found) select.value = '';
  }

  function setZipMode(input, country) {
    if (!input) return;
    if (country === 'CA') {
      input.setAttribute('inputmode', 'text');
      input.setAttribute('autocapitalize', 'characters');
      input.setAttribute('maxlength', '7');
    } else {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('maxlength', '10');
    }
  }

  function inputValue(selector) {
    var node = payEl(selector);
    return node ? String(node.value || '') : '';
  }

  function setInputValue(selector, value) {
    var node = payEl(selector);
    if (!node || value == null) return;
    node.value = String(value);
  }

  function billingCountry() {
    return countryOf(billingDefault);
  }

  function readBillForm() {
    return {
      address1: inputValue('[data-pay-bill-address1]'),
      city: inputValue('[data-pay-bill-city]'),
      state: inputValue('[data-pay-bill-state]'),
      zip: inputValue('[data-pay-bill-zip]'),
      country: billingCountry()
    };
  }

  function writeBillForm(addr) {
    addr = addr || {};
    var country = addr.country ? countryOf(addr) : billingCountry();
    fillStateSelect(payEl('[data-pay-bill-state]'), country, addr.state || '');
    setZipMode(payEl('[data-pay-bill-zip]'), country);
    setInputValue('[data-pay-bill-address1]', addr.address1 == null ? '' : addr.address1);
    setInputValue('[data-pay-bill-city]', addr.city == null ? '' : addr.city);
    setInputValue('[data-pay-bill-zip]', addr.zip == null ? '' : addr.zip);
  }

  function readAvs() {
    return {
      address1: inputValue('[data-pay-avs-address1]'),
      zip: inputValue('[data-pay-avs-zip]')
    };
  }

  function writeAvs(addr) {
    addr = addr || {};
    setZipMode(payEl('[data-pay-avs-zip]'), billingCountry());
    setInputValue('[data-pay-avs-address1]', addr.address1 == null ? '' : addr.address1);
    setInputValue('[data-pay-avs-zip]', addr.zip == null ? '' : addr.zip);
  }

  function readCardStreetZip() {
    return {
      address1: inputValue('[data-pay-card-address1]'),
      zip: inputValue('[data-pay-card-zip]')
    };
  }

  function writeCardStreetZip(addr) {
    addr = addr || {};
    var country = addr.country ? countryOf(addr) : billingCountry();
    setZipMode(payEl('[data-pay-card-zip]'), country);
    setInputValue('[data-pay-card-address1]', addr.address1 == null ? '' : addr.address1);
    setInputValue('[data-pay-card-zip]', addr.zip == null ? '' : addr.zip);
  }

  function enteredPayload(addr) {
    var country = countryOf(addr);
    var body = {
      address1: String(addr.address1 || '').trim(),
      city: String(addr.city || '').trim(),
      state: String(addr.state || '').toUpperCase(),
      zip: normalizeZip(addr.zip, country),
      country: country
    };
    var line2 = String(addr.address2 || '').trim();
    if (line2) body.address2 = line2;
    return body;
  }

  function setBillingFieldError(field, text) {
    var node = payEl('[data-pay-bill-field-error="' + field + '"]');
    if (node) {
      node.textContent = text || '';
      node.hidden = !text;
    }
    var input = payEl('[data-pay-bill-' + field + ']');
    if (input) {
      if (text) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function clearBillingFieldErrors() {
    BILLING_FIELDS.forEach(function (field) { setBillingFieldError(field, ''); });
  }

  function setAvsFieldError(field, text) {
    var node = payEl('[data-pay-avs-field-error="' + field + '"]');
    if (node) {
      node.textContent = text || '';
      node.hidden = !text;
    }
    var input = payEl('[data-pay-avs-' + field + ']');
    if (input) {
      if (text) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function clearAvsFieldErrors() {
    AVS_FIELDS.forEach(function (field) { setAvsFieldError(field, ''); });
  }

  function showBillingError(text) {
    var node = payEl('[data-pay-billing-error]');
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
  }

  function paintBilling() {
    var status = payEl('[data-pay-billing-status]');
    if (status) status.hidden = !addressesLoading;
    var block = payEl('[data-pay-billing]');
    if (block) block.setAttribute('aria-busy', addressesLoading ? 'true' : 'false');
    var summary = payEl('[data-pay-billing-summary]');
    var form = payEl('[data-pay-billing-form]');
    var avs = payEl('[data-pay-billing-avs]');
    var link = payEl('[data-pay-billing-avs-open]');
    var hint = payEl('[data-pay-billing-hint]');
    if (addressesLoading) {
      if (summary) summary.hidden = true;
      if (form) form.hidden = true;
      if (avs) avs.hidden = true;
      if (link) link.hidden = true;
      if (hint) hint.hidden = true;
      return;
    }
    var line = payEl('[data-pay-billing-line]');
    if (summary) summary.hidden = !billingDefault;
    if (line) line.textContent = billingDefault ? addressLine(billingDefault) : '';
    if (form) form.hidden = !billingNeedsState;
    if (avs) avs.hidden = !billingAvsOpen;
    var stateReady = !!(billingDefault && stateIsValid(billingDefault.state, countryOf(billingDefault)));
    if (link) {
      link.hidden = !stateReady || billingNeedsState;
      link.setAttribute('aria-expanded', billingAvsOpen ? 'true' : 'false');
    }
    if (hint) hint.hidden = !(billingNeedsState && !inputValue('[data-pay-bill-state]'));
  }

  function noteBillingEdited() {
    if (payBusy) return;
    if (payAttempted) {
      payKey = mintKey();
      payAttempted = false;
    }
  }

  function avsProblems() {
    var problems = {};
    var country = billingCountry();
    var avs = readAvs();
    var street = String(avs.address1 || '').trim();
    if (!street || street.length > 100) problems.address1 = BILLING_MSG.address1;
    if (!zipIsValid(avs.zip, country)) problems.zip = BILLING_MSG.zip;
    return problems;
  }

  function cardStreetZipProblems() {
    var problems = {};
    var country = billingCountry();
    var entered = readCardStreetZip();
    var street = String(entered.address1 || '').trim();
    if (!street || street.length > 100) problems.address1 = BILLING_MSG.address1;
    if (!zipIsValid(entered.zip, country)) problems.zip = BILLING_MSG.zip;
    return problems;
  }

  function cardStreetZipReady() {
    var keys = Object.keys(cardStreetZipProblems());
    return keys.length === 0;
  }

  function billingAddressReady() {
    if (!addressesLoaded || addressesLoading) return false;
    if (billingNeedsState) return addressIsValid(readBillForm());
    if (billingAvsOpen) {
      var keys = Object.keys(avsProblems());
      return keys.length === 0;
    }
    return true;
  }

  function billingPayload() {
    if (billingNeedsState) return enteredPayload(readBillForm());
    if (billingAvsOpen) {
      var base = billingDefault || {};
      var country = billingCountry();
      var avs = readAvs();
      return {
        address1: String(avs.address1 || '').trim(),
        city: String(base.city || '').trim(),
        state: String(base.state || '').toUpperCase(),
        zip: normalizeZip(avs.zip, country),
        country: country
      };
    }
    return null;
  }

  function toggleAvs() {
    if (payBusy || !billingDefault || billingNeedsState) return;
    noteBillingEdited();
    billingAvsOpen = !billingAvsOpen;
    if (billingAvsOpen) writeAvs(billingDefault);
    clearAvsFieldErrors();
    showBillingError('');
    paintBilling();
    syncPayButton();
    if (billingAvsOpen) {
      var focus = payEl('[data-pay-avs-address1]');
      if (focus && focus.focus) focus.focus();
    }
  }

  function prefillCardIfBlank() {
    var zipNode = payEl('[data-pay-card-zip]');
    setZipMode(zipNode, billingCountry());
    if (!billingDefault || !cardStepOpen()) return;
    if (inputValue('[data-pay-card-address1]').trim() || inputValue('[data-pay-card-zip]').trim()) return;
    writeCardStreetZip(billingDefault);
    syncCardSave();
  }

  function useDefaultBilling() {
    billingDefault = null;
    for (var i = 0; i < payAddresses.length; i++) {
      if (payAddresses[i].default_billing === true) {
        billingDefault = payAddresses[i];
        break;
      }
    }
    billingNeedsState = !!(billingDefault && !stateIsValid(billingDefault.state, countryOf(billingDefault)));
    billingAvsOpen = false;
    clearBillingFieldErrors();
    clearAvsFieldErrors();
    showBillingError('');
    if (billingDefault) {
      writeBillForm(billingDefault);
      writeAvs(billingDefault);
    } else {
      writeBillForm({ country: 'US' });
      writeAvs({});
    }
    prefillCardIfBlank();
    paintBilling();
    syncPayButton();
  }

  function publicAddress(raw) {
    return {
      id: String(raw.id),
      label: raw.label ? String(raw.label) : '',
      addressee: raw.addressee ? String(raw.addressee) : '',
      address1: raw.address1 ? String(raw.address1) : '',
      address2: raw.address2 ? String(raw.address2) : '',
      city: raw.city ? String(raw.city) : '',
      state: raw.state ? String(raw.state).toUpperCase() : '',
      zip: raw.zip ? String(raw.zip) : '',
      country: raw.country ? String(raw.country).toUpperCase() : '',
      default_billing: raw.default_billing === true,
      default_shipping: raw.default_shipping === true,
      valid: raw.valid === true
    };
  }

  function resetBilling() {
    payAddresses = [];
    billingDefault = null;
    billingNeedsState = false;
    billingAvsOpen = false;
    addressesLoaded = false;
    addressesLoading = false;
    clearBillingFieldErrors();
    clearAvsFieldErrors();
    showBillingError('');
    writeBillForm({ country: 'US' });
    writeAvs({});
    paintBilling();
    syncPayButton();
  }

  function setAddressesLoading() {
    addressesLoading = true;
    addressesLoaded = false;
    payAddresses = [];
    billingDefault = null;
    billingNeedsState = false;
    billingAvsOpen = false;
    paintBilling();
    syncPayButton();
  }

  /* A failed address load still lets the dealer pay. The RESTlet uses the
     address on file and returns billing_state_missing if it needs a state. */
  function failAddresses() {
    addressesLoading = false;
    addressesLoaded = true;
    billingDefault = null;
    billingNeedsState = false;
    billingAvsOpen = false;
    clearBillingFieldErrors();
    clearAvsFieldErrors();
    showBillingError('');
    writeBillForm({ country: 'US' });
    writeAvs({});
    paintBilling();
    syncPayButton();
  }

  function loadAddresses(session) {
    setAddressesLoading();
    proxyFetch('/invoices/pay/addresses', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (res) {
      if (session !== paySession || !payModalOpen()) return;
      addressesLoading = false;
      var code = payErrorCode(res.body);
      if (res.status === 403 || code === 'pay_disabled') {
        invoicePayEnabled = false;
        paintPayChrome();
        showPayError('Online payment is not available.', true);
        hidePayCta();
        addressesLoaded = false;
        paintBilling();
        syncPayButton();
        return;
      }
      if (!res.ok) {
        failAddresses();
        return;
      }
      var list = (res.body && res.body.addresses) || [];
      payAddresses = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].id != null && list[i].id !== '') payAddresses.push(publicAddress(list[i]));
      }
      addressesLoaded = true;
      useDefaultBilling();
    }).catch(function () {
      if (session !== paySession || !payModalOpen()) return;
      failAddresses();
    });
  }

  function billFieldName(node) {
    for (var i = 0; i < BILLING_FIELDS.length; i++) {
      if (node.hasAttribute('data-pay-bill-' + BILLING_FIELDS[i])) return BILLING_FIELDS[i];
    }
    return '';
  }

  function onBillBlur(e) {
    var t = e.target;
    if (!t || !t.hasAttribute) return;
    var country = billingCountry();
    if ((t.hasAttribute('data-pay-bill-zip') || t.hasAttribute('data-pay-avs-zip')) && country === 'CA' && zipIsValid(t.value, 'CA')) {
      t.value = normalizeZip(t.value, 'CA');
    }
    if (t.hasAttribute('data-pay-avs-address1') || t.hasAttribute('data-pay-avs-zip')) {
      var avsField = t.hasAttribute('data-pay-avs-zip') ? 'zip' : 'address1';
      var avs = avsProblems();
      if (t.value && avs[avsField]) setAvsFieldError(avsField, avs[avsField]);
      syncPayButton();
      return;
    }
    var field = billFieldName(t);
    if (!field) return;
    var problems = addressProblems(readBillForm());
    if (field === 'state') {
      if (problems.state) setBillingFieldError('state', problems.state);
      return;
    }
    if (t.value && problems[field]) setBillingFieldError(field, problems[field]);
    syncPayButton();
  }

  function stateOnFileIsCode() {
    return !!(billingDefault && stateIsValid(billingDefault.state, countryOf(billingDefault)));
  }

  function applyOnFilePrefill(onFile) {
    if (!onFile || typeof onFile !== 'object') return;
    var street = onFile.address1 != null ? String(onFile.address1) : null;
    var city = onFile.city != null ? String(onFile.city) : null;
    var zip = onFile.zip != null ? String(onFile.zip) : null;
    if (billingNeedsState) {
      if (street != null) setInputValue('[data-pay-bill-address1]', street);
      if (city != null) setInputValue('[data-pay-bill-city]', city);
      if (zip != null) setInputValue('[data-pay-bill-zip]', zip);
      return;
    }
    billingAvsOpen = true;
    if (street != null) setInputValue('[data-pay-avs-address1]', street);
    if (zip != null) setInputValue('[data-pay-avs-zip]', zip);
    setZipMode(payEl('[data-pay-avs-zip]'), billingCountry());
  }

  function showBillingServerError(message, onFile, code) {
    var flow = payEl('[data-pay-flow]');
    var result = payEl('[data-pay-result]');
    if (flow) flow.hidden = false;
    if (result) result.hidden = true;
    /* No state on file: the dealer has to pick one. Street, city, and ZIP
       come from on_file when the RESTlet sends them. */
    if ((code === 'billing_state_missing' || code === 'billing_invalid') && !stateOnFileIsCode()) {
      billingNeedsState = true;
      billingAvsOpen = false;
    }
    if (onFile) applyOnFilePrefill(onFile);
    clearBillingFieldErrors();
    clearAvsFieldErrors();
    showBillingError(message);
    paintBilling();
    syncPayButton();
    var focus = payEl('[data-pay-billing-error]');
    if (focus && focus.focus) focus.focus();
  }

  function hasBillingFieldErrors(errors) {
    if (!errors || typeof errors !== 'object') return false;
    var keys = Object.keys(errors);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf('billing_address.') === 0) return true;
    }
    return false;
  }

  function errorText(value) {
    if (Array.isArray(value)) return value.filter(function (m) { return typeof m === 'string'; }).join(' ');
    if (typeof value === 'string') return value;
    return '';
  }

  function showBillingFieldErrors(body) {
    var errors = (body && body.errors) || {};
    var keys = Object.keys(errors);
    var parsed = [];
    var needsForm = billingNeedsState;
    var i;
    for (i = 0; i < keys.length; i++) {
      if (keys[i].indexOf('billing_address.') !== 0) continue;
      var field = keys[i].slice('billing_address.'.length);
      var text = errorText(errors[keys[i]]) || BILLING_MSG[field] || 'Check the billing address.';
      parsed.push({ field: field, text: text });
      if (field === 'state' || field === 'city' || field === 'country' || field === 'address2') needsForm = true;
    }
    var flow = payEl('[data-pay-flow]');
    var result = payEl('[data-pay-result]');
    if (flow) flow.hidden = false;
    if (result) result.hidden = true;
    clearBillingFieldErrors();
    clearAvsFieldErrors();
    if (needsForm) {
      billingNeedsState = true;
      billingAvsOpen = false;
      for (i = 0; i < parsed.length; i++) setBillingFieldError(parsed[i].field, parsed[i].text);
    } else {
      billingAvsOpen = true;
      for (i = 0; i < parsed.length; i++) {
        if (parsed[i].field === 'address1' || parsed[i].field === 'zip') setAvsFieldError(parsed[i].field, parsed[i].text);
      }
    }
    showBillingError(payMessage(body, 'Choose or enter a valid billing address.'));
    paintBilling();
    syncPayButton();
    var first = parsed.length ? parsed[0].field : '';
    var node = null;
    if (first && needsForm) node = payEl('[data-pay-bill-' + first + ']');
    else if (first) node = payEl('[data-pay-avs-' + first + ']');
    if (node && node.focus) node.focus();
  }

  function initAddressWidgets() {
    fillStateSelect(payEl('[data-pay-bill-state]'), 'US', '');
    setZipMode(payEl('[data-pay-bill-zip]'), 'US');
    setZipMode(payEl('[data-pay-avs-zip]'), 'US');
    setZipMode(payEl('[data-pay-card-zip]'), 'US');
  }

  function scheduleQuote() {
    quoteSeq += 1;
    clearTimeout(quoteTimer);
    quoteBusy = true;
    payQuote = null;
    setQuoteStatus(true);
    syncPayButton();
    quoteTimer = setTimeout(fetchQuoteNow, 300);
  }

  function fetchQuoteNow() {
    clearTimeout(quoteTimer);
    var ids = selectedIds();
    var seq = ++quoteSeq;
    if (!ids.length) {
      quoteBusy = false;
      payQuote = null;
      paintSummary(null);
      setQuoteStatus(false);
      syncPayButton();
      return;
    }
    if (ids.length > 50) {
      quoteBusy = false;
      payQuote = null;
      paintSummary(null);
      setQuoteStatus(false);
      showPayError('Select 50 invoices or fewer.');
      syncPayButton();
      return;
    }
    quoteBusy = true;
    setQuoteStatus(true);
    syncPayButton();
    var path = '/invoices/pay/quote?' + ids.map(function (id) {
      return 'ids[]=' + encodeURIComponent(id);
    }).join('&');
    proxyFetch(path, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (seq !== quoteSeq || !payModalOpen()) return;
      quoteBusy = false;
      setQuoteStatus(false);
      var code = payErrorCode(res.body);
      if (res.ok && res.body && res.body.total != null) {
        payQuote = res.body;
        payQuote._ids = ids.slice();
        paintSummary(payQuote);
        if (!stickyPayError) clearPayError();
      } else if (res.status === 403 || code === 'pay_disabled') {
        payQuote = null;
        paintSummary(null);
        invoicePayEnabled = false;
        paintPayChrome();
        showPayError('Online payment is not available.', true);
        hidePayCta();
      } else if (res.status === 422 || code === 'invoice_not_open') {
        payQuote = null;
        paintSummary(null);
        showPayError('One or more selected invoices are no longer open.');
      } else {
        payQuote = null;
        paintSummary(null);
        showPayError(PAY_GENERIC);
      }
      syncPayButton();
    }).catch(function () {
      if (seq !== quoteSeq || !payModalOpen()) return;
      quoteBusy = false;
      setQuoteStatus(false);
      payQuote = null;
      paintSummary(null);
      showPayError(PAY_GENERIC);
      syncPayButton();
    });
  }

  function loadCards(session) {
    setCardsLoading();
    proxyFetch('/invoices/pay/cards', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (session !== paySession || !payModalOpen()) return;
      var status = payEl('[data-pay-cards-status]');
      if (status) status.hidden = true;
      var code = payErrorCode(res.body);
      if (res.status === 403 || code === 'pay_disabled') {
        invoicePayEnabled = false;
        paintPayChrome();
        showPayError('Online payment is not available.', true);
        hidePayCta();
        return;
      }
      if (!res.ok) {
        showPayError(PAY_GENERIC, true);
        var addBtn = payEl('[data-pay-add-open]');
        if (addBtn) addBtn.hidden = false;
        hidePayCta();
        return;
      }
      renderCards((res.body && res.body.cards) || []);
      /* Quote even when the list is empty, so the summary is ready before a card exists. */
      fetchQuoteNow();
      syncPayButton();
    }).catch(function () {
      if (session !== paySession || !payModalOpen()) return;
      var status = payEl('[data-pay-cards-status]');
      if (status) status.hidden = true;
      showPayError(PAY_GENERIC, true);
      hidePayCta();
    });
  }

  function onSelectionChange() {
    if (payBusy) return;
    if (payAttempted) {
      payKey = mintKey();
      payAttempted = false;
    }
    stickyPayError = false;
    clearPayError();
    payQuote = null;
    syncSelectAll();
    syncPayButton();
    /* Re-quote on every change, even before a card is saved: the summary must
       follow the ticked invoices (Akshay, PAY-03). */
    scheduleQuote();
  }

  function onCardChange() {
    if (payBusy) return;
    if (payAttempted) {
      payKey = mintKey();
      payAttempted = false;
    }
  }

  function showFlow() {
    leaveAddStep();
    var flow = payEl('[data-pay-flow]');
    var result = payEl('[data-pay-result]');
    if (flow) flow.hidden = false;
    if (result) result.hidden = true;
    syncPayButton();
  }

  function focusPayDialog() {
    var panel = payEl('#DashPayDialog');
    if (panel) panel.focus();
  }

  function focusCard() {
    var radio = payEl('[data-pay-cards] input[type="radio"]');
    if (radio) radio.focus();
    else focusPayDialog();
  }

  function showResult(kind, title, paras, actions) {
    leaveAddStep();
    var flow = payEl('[data-pay-flow]');
    var box = payEl('[data-pay-result]');
    if (flow) flow.hidden = true;
    if (!box) return;
    box.className = 'dash-pay__result dash-pay__result--' + kind;
    box.hidden = false;
    var heading = payEl('[data-pay-result-title]');
    if (heading) heading.textContent = title;
    var body = payEl('[data-pay-result-body]');
    clearChildren(body);
    (paras || []).forEach(function (text) {
      if (!text) return;
      var p = document.createElement('p');
      p.textContent = text;
      body.appendChild(p);
    });
    var retry = payEl('[data-pay-retry]');
    var again = payEl('[data-pay-again]');
    var done = payEl('[data-pay-done]');
    if (retry) retry.hidden = !actions.retry;
    if (again) again.hidden = !actions.again;
    if (done) done.hidden = actions.done === false;
    var focus = (actions.retry && retry) || (actions.again && again) || done;
    if (focus) focus.focus();
  }

  function successLines(p) {
    var lines = [];
    if (p.number) lines.push('Payment ' + p.number);
    if (p.card_label) lines.push(String(p.card_label));
    if (p.total != null) lines.push('Total charged ' + money(p.total));
    var email = app.dataset.customerEmail || '';
    lines.push(email ? 'Receipt emailed to ' + email + '.' : 'Receipt emailed.');
    return lines;
  }

  function setPayBusy(on) {
    payBusy = on;
    var flow = payEl('[data-pay-flow]');
    if (flow) {
      Array.prototype.forEach.call(flow.querySelectorAll('input, select, button'), function (node) {
        if (node.hasAttribute('data-pay-submit')) return;
        node.disabled = on;
      });
    }
    syncCloseLocked();
    syncPayButton();
    if (on) focusPayDialog();
  }

  function paymentReference(body) {
    if (!body || body.payment_id == null || body.payment_id === '') return '';
    return String(body.payment_id);
  }

  function showUnconfirmed(lines) {
    showResult('unconfirmed', 'Payment not confirmed', lines, { done: true });
  }

  function handlePayResponse(res) {
    setPayBusy(false);
    payAttempted = false;
    var body = res.body || {};
    var code = payErrorCode(body);

    /* The charge may already have happened. Portal: HTTP 409, error gateway_unknown, no payment_id. */
    if (code === 'gateway_unknown') {
      var ref = paymentReference(body);
      var lines = [payMessage(body, PAY_UNCONFIRMED)];
      if (ref) lines.push('Payment reference ' + ref);
      payReloadOnClose = true;
      showUnconfirmed(lines);
      return;
    }

    /* An earlier payment on one of these invoices is still unconfirmed. */
    if (code === 'payment_unconfirmed') {
      showUnconfirmed([payMessage(body, PAY_EARLIER)]);
      return;
    }

    /* This idempotency key was already used. Do not start another charge from here. */
    if (code === 'key_used') {
      showResult('unconfirmed', 'Payment already submitted', [payMessage(body, PAY_KEY_USED)], { done: true });
      return;
    }

    if (body.status === 'declined' || res.status === 402) {
      payKey = mintKey();
      showResult('declined', 'Payment declined', [body.reason || payMessage(body, 'The card was declined.')], { retry: true });
      return;
    }
    /* HTTP 200 {status:paid, payment}. replay:true, when present, is the same payment. */
    if (body.status === 'paid' && (res.ok || body.replay === true)) {
      paySucceeded = true;
      showResult('paid', 'Payment received', successLines(body.payment || {}), { done: true });
      return;
    }
    if (PAY_VALIDATION[code]) {
      payKey = mintKey();
      showResult('error', 'Payment not completed', [payMessage(body, PAY_GENERIC)], { retry: true });
      if (code === 'total_mismatch') fetchQuoteNow();
      return;
    }
    payKey = mintKey();
    if (res.status === 403 || code === 'pay_disabled') {
      invoicePayEnabled = false;
      paintPayChrome();
      showPayError('Online payment is not available.', true);
      hidePayCta();
      return;
    }
    if (code === 'card_not_found') {
      showPayError(PAY_GENERIC, true);
      loadCards(paySession);
      return;
    }
    if (code === 'total_changed') {
      showPayError(PAY_GENERIC, true);
      fetchQuoteNow();
      return;
    }
    /* A missing or rejected billing address stays on this step. The invoice
       selection and the card stay put. */
    if (code === 'billing_state_missing' || code === 'billing_invalid') {
      payKey = mintKey();
      var billingFallback = code === 'billing_invalid' ? 'Enter a valid billing address.' : 'Please contact AR.';
      showBillingServerError(payMessage(body, billingFallback), body.on_file, code);
      return;
    }
    /* The address on file could not be updated, or the card was not applied. */
    if (code === 'billing_update_failed' || code === 'card_not_applied') {
      var updateFallback = code === 'billing_update_failed'
        ? 'We could not update the billing address on file. Please contact AR.'
        : PAY_GENERIC;
      showResult('error', 'Payment not completed', [payMessage(body, updateFallback)], { again: true });
      return;
    }
    if (code === 'validation_failed' && hasBillingFieldErrors(body.errors)) {
      payKey = mintKey();
      showBillingFieldErrors(body);
      return;
    }
    /* NetSuite refused the payment and said why (e.g. a card error): show that reason. */
    if (body.message && res.status === 422) {
      showResult('error', 'Payment not completed', [body.message], { again: true });
      return;
    }
    showResult('error', 'Something went wrong', ['Please try again.'], { again: true });
  }

  function submitPay() {
    if (payBusy || !payQuote || !payKey) return;
    var ids = selectedIds();
    var token = selectedToken();
    if (!token || !sameIds(payQuote._ids, ids) || !billingAddressReady()) return;
    var billing = billingPayload();
    var payBody = {
      idempotency_key: payKey,
      invoice_ids: ids,
      token_id: token,
      expected_total: amountString(payQuote.total)
    };
    if (billing) payBody.billing_address = billing;
    payAttempted = true;
    clearPayError();
    clearBillingFieldErrors();
    clearAvsFieldErrors();
    showBillingError('');
    setPayBusy(true);
    proxyFetch('/invoices/pay', {
      method: 'POST',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payBody)
    }).then(function (res) {
      if (!payModalOpen()) {
        setPayBusy(false);
        var closedBody = res.body || {};
        var closedCode = payErrorCode(closedBody);
        if (closedBody.status === 'paid' && (res.ok || closedBody.replay === true)) {
          reloadOpenInvoices();
        } else if (closedCode === 'gateway_unknown') {
          reloadOpenInvoices();
        }
        return;
      }
      handlePayResponse(res);
    }).catch(function () {
      setPayBusy(false);
      if (payModalOpen()) showPayError(PAY_GENERIC, true);
    });
  }

  function openPayModal(preselectId) {
    if (!payUiOn() || payBusy || !payRoot) return;
    if (payRoot.parentNode !== document.body) document.body.appendChild(payRoot);
    paySession += 1;
    var session = paySession;
    payKey = mintKey();
    payAttempted = false;
    paySucceeded = false;
    payReloadOnClose = false;
    stickyPayError = false;
    payQuote = null;
    quoteBusy = false;
    cardBlocked = false;
    cardBlockMessage = '';
    clearTimeout(quoteTimer);
    quoteSeq += 1;
    clearPayError();
    showFlow();
    renderInvoices(preselectId);
    paintSummary(null);
    payRoot.hidden = false;
    document.documentElement.classList.add('dash-pay-open');
    document.body.classList.add('dash-pay-open');
    payReturnFocus = document.activeElement;
    resetBilling();
    focusPayDialog();
    loadCards(session);
    loadAddresses(session);
  }

  function closePayModal() {
    if (payBusy || cardBusy || !payModalOpen()) return;
    leaveAddStep();
    payRoot.hidden = true;
    document.documentElement.classList.remove('dash-pay-open');
    document.body.classList.remove('dash-pay-open');
    quoteSeq += 1;
    clearTimeout(quoteTimer);
    quoteBusy = false;
    var back = payReturnFocus;
    payReturnFocus = null;
    if (back && typeof back.focus === 'function' && document.contains(back)) back.focus();
    if (paySucceeded || payReloadOnClose) {
      paySucceeded = false;
      payReloadOnClose = false;
      reloadOpenInvoices();
    }
    resetBilling();
  }

  function payFocusable(root) {
    if (!root) return [];
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])';
    return Array.prototype.filter.call(root.querySelectorAll(sel), function (node) {
      if (node.closest('[hidden]')) return false;
      return node.getClientRects().length > 0;
    });
  }

  function onPayKeydown(e) {
    if (!payModalOpen()) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closePayModal();
      return;
    }
    if (e.key !== 'Tab') return;
    var panel = payEl('#DashPayDialog');
    var nodes = payFocusable(panel);
    if (!nodes.length) {
      e.preventDefault();
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || active === panel || !panel.contains(active)) {
        e.preventDefault();
        last.focus();
      }
    } else if (active === last || !panel.contains(active)) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ------------------------------------------------------- add a card */

  /* The card number, expiry, name, and billing address live in the inputs and,
     during Save, in one local string inside saveCard. They are not written to
     storage, the console, analytics, the URL, or the card list. */
  var CARD_FIELDS = ['number', 'exp_month', 'exp_year', 'name_on_card', 'address1', 'zip'];
  var CARD_FIELD_INPUT = {
    number: '[data-pay-card-number]',
    exp_month: '[data-pay-card-month]',
    exp_year: '[data-pay-card-year]',
    name_on_card: '[data-pay-card-name]',
    address1: '[data-pay-card-address1]',
    zip: '[data-pay-card-zip]'
  };
  var CARD_FIELD_FALLBACK = {
    number: 'Enter a valid card number.',
    exp_month: 'Enter a valid expiration month.',
    exp_year: 'Enter a valid expiration year.',
    name_on_card: 'Enter the name on the card.',
    address1: 'Enter the billing street address and city.',
    zip: 'Enter a valid billing ZIP code.'
  };

  function fieldInput(field) {
    return payEl(CARD_FIELD_INPUT[field] || 'x');
  }

  function cardDigits() {
    var input = fieldInput('number');
    return input ? input.value.replace(/\D/g, '').slice(0, 19) : '';
  }

  function detectBrand(digits) {
    if (!digits) return null;
    if (digits.charAt(0) === '4') return { id: 'visa', label: 'Visa' };
    if (/^3[47]/.test(digits)) return { id: 'amex', label: 'Amex' };
    if (/^5[1-5]/.test(digits)) return { id: 'mastercard', label: 'Mastercard' };
    if (/^(222[1-9]|22[3-9]\d|2[3-6]\d\d|27[01]\d|2720)/.test(digits)) return { id: 'mastercard', label: 'Mastercard' };
    if (/^(6011|65|64[4-9])/.test(digits)) return { id: 'discover', label: 'Discover' };
    return null;
  }

  function formatCardNumber(digits) {
    var brand = detectBrand(digits);
    var limit = brand && brand.id === 'amex' ? 15 : 19;
    var d = digits.slice(0, limit);
    if (brand && brand.id === 'amex') {
      var parts = [];
      if (d.length) parts.push(d.slice(0, 4));
      if (d.length > 4) parts.push(d.slice(4, 10));
      if (d.length > 10) parts.push(d.slice(10, 15));
      return parts.join(' ');
    }
    var groups = [];
    for (var i = 0; i < d.length; i += 4) groups.push(d.slice(i, i + 4));
    return groups.join(' ');
  }

  function luhnValid(digits) {
    if (!/^\d{13,19}$/.test(digits)) return false;
    var sum = 0;
    var alt = false;
    for (var i = digits.length - 1; i >= 0; i--) {
      var n = digits.charCodeAt(i) - 48;
      if (alt) {
        n *= 2;
        if (n > 9) n -= 9;
      }
      sum += n;
      alt = !alt;
    }
    return sum % 10 === 0;
  }

  function expiryState() {
    var monthInput = fieldInput('exp_month');
    var yearInput = fieldInput('exp_year');
    if (!monthInput || !yearInput) return 'empty';
    if (monthInput.value === '' || yearInput.value === '') return 'empty';
    if (!/^\d{1,2}$/.test(monthInput.value) || !/^\d{4}$/.test(yearInput.value)) return 'invalid';
    var month = parseInt(monthInput.value, 10);
    var year = parseInt(yearInput.value, 10);
    var now = new Date();
    var currentYear = now.getFullYear();
    if (month < 1 || month > 12 || year < currentYear || year > currentYear + 15) return 'invalid';
    if (year === currentYear && month < (now.getMonth() + 1)) return 'expired';
    return 'ok';
  }

  function nameOk() {
    var input = fieldInput('name_on_card');
    if (!input) return false;
    var n = input.value.trim().length;
    return n >= 2 && n <= 60;
  }

  function cardFormReady() {
    return luhnValid(cardDigits()) && expiryState() === 'ok' && nameOk() && cardStreetZipReady();
  }

  function cooldownRemaining() {
    if (!cardCooldownUntil) return 0;
    var left = Math.ceil((cardCooldownUntil - Date.now()) / 1000);
    return left > 0 ? left : 0;
  }

  function scrubCardText(text) {
    var out = String(text || '');
    var numberInput = fieldInput('number');
    var typed = numberInput ? numberInput.value : '';
    if (typed && typed.replace(/\D/g, '').length >= 4) {
      out = out.split(typed).join('');
      out = out.split(typed.replace(/\D/g, '')).join('');
    }
    var monthInput = fieldInput('exp_month');
    var yearInput = fieldInput('exp_year');
    var nameInput = fieldInput('name_on_card');
    var year = yearInput ? yearInput.value.trim() : '';
    var name = nameInput ? nameInput.value.trim() : '';
    if (year.length === 4) out = out.split(year).join('');
    if (name.length >= 4) out = out.split(name).join('');
    if (monthInput && /^\d{2}$/.test(monthInput.value)) out = out.split(monthInput.value).join('');
    out = out.replace(/\d(?:[ \t-]*\d){12,18}/g, '');
    return out.replace(/[ \t]{2,}/g, ' ').trim();
  }

  function safePayMessage(body, fallback) {
    var text = scrubCardText(payMessage(body, fallback));
    return text || fallback;
  }

  function setFieldError(field, text) {
    var node = payEl('[data-pay-field-error="' + field + '"]');
    var clean = scrubCardText(text);
    if (node) {
      node.textContent = clean;
      node.hidden = !clean;
    }
    var input = fieldInput(field);
    if (input) {
      if (clean) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function clearAddFieldErrors() {
    CARD_FIELDS.forEach(function (field) { setFieldError(field, ''); });
  }

  function showAddError(text) {
    var node = payEl('[data-pay-add-error]');
    if (!node) return;
    var clean = scrubCardText(text);
    node.textContent = clean;
    node.hidden = !clean;
  }

  function clearAddError() {
    showAddError('');
  }

  function paintBrand(digits) {
    var node = payEl('[data-pay-brand]');
    if (!node) return;
    var brand = detectBrand(digits);
    if (!brand) {
      node.hidden = true;
      node.textContent = '';
      node.removeAttribute('data-brand');
      return;
    }
    node.hidden = false;
    node.setAttribute('data-brand', brand.id);
    node.textContent = brand.label;
  }

  function clearCardFields() {
    CARD_FIELDS.forEach(function (field) {
      var input = fieldInput(field);
      if (!input) return;
      input.value = '';
      input.removeAttribute('aria-invalid');
    });
    setZipMode(payEl('[data-pay-card-zip]'), billingCountry());
    paintBrand('');
    clearAddFieldErrors();
    clearAddError();
    syncCardSave();
  }

  function syncCloseLocked() {
    if (!payRoot) return;
    var locked = payBusy || cardBusy;
    Array.prototype.forEach.call(payRoot.querySelectorAll('[data-pay-close]'), function (node) {
      if (node.tagName === 'BUTTON') node.disabled = locked;
    });
  }

  function syncCardSave() {
    var btn = payEl('[data-pay-card-save]');
    if (!btn) return;
    var waiting = cooldownRemaining() > 0;
    var ready = cardFormReady() && !cardBusy && !cardBlocked && !waiting;
    btn.hidden = !!cardBlocked;
    btn.disabled = !ready;
    btn.classList.toggle('is-busy', !!cardBusy);
    btn.setAttribute('aria-busy', cardBusy ? 'true' : 'false');
    var spinner = payEl('[data-pay-card-spinner]');
    if (spinner) spinner.hidden = !cardBusy;
    var label = payEl('[data-pay-card-save-label]');
    if (label && !cardBusy) label.textContent = 'Save card';
  }

  function cardStepOpen() {
    var add = payEl('[data-pay-add]');
    return !!(add && !add.hidden && payModalOpen());
  }

  function leaveAddStep() {
    clearCardFields();
    var add = payEl('[data-pay-add]');
    if (add) add.hidden = true;
    var title = payEl('#DashPayTitle');
    if (title) title.textContent = 'Pay invoices';
  }

  function openAddCard() {
    if (payBusy || cardBusy) return;
    var flow = payEl('[data-pay-flow]');
    var result = payEl('[data-pay-result]');
    var add = payEl('[data-pay-add]');
    if (flow) flow.hidden = true;
    if (result) result.hidden = true;
    if (add) add.hidden = false;
    var title = payEl('#DashPayTitle');
    if (title) title.textContent = 'Add a card';
    if (billingDefault) writeCardStreetZip(billingDefault);
    else writeCardStreetZip({});
    clearAddFieldErrors();
    clearAddError();
    if (cardBlocked) showAddError(cardBlockMessage);
    else if (cooldownRemaining() > 0) scheduleCooldownTick();
    syncCardSave();
    var number = fieldInput('number');
    if (number) number.focus();
  }

  function keepDigits(input, max) {
    var raw = input.value;
    var digits = raw.replace(/\D/g, '').slice(0, max);
    if (digits === raw) return;
    var caret = input.selectionStart || 0;
    var before = raw.slice(0, caret).replace(/\D/g, '').length;
    input.value = digits;
    var next = Math.min(before, digits.length);
    if (input.setSelectionRange) input.setSelectionRange(next, next);
  }

  function onCardNumberInput() {
    var input = fieldInput('number');
    if (!input) return;
    var raw = input.value;
    var caret = input.selectionStart || 0;
    var digitsBefore = raw.slice(0, caret).replace(/\D/g, '').length;
    var formatted = formatCardNumber(raw.replace(/\D/g, ''));
    input.value = formatted;
    var seen = 0;
    var pos = 0;
    while (pos < formatted.length && seen < digitsBefore) {
      var ch = formatted.charAt(pos);
      if (ch >= '0' && ch <= '9') seen += 1;
      pos += 1;
    }
    if (input.setSelectionRange) input.setSelectionRange(pos, pos);
    paintBrand(input.value.replace(/\D/g, ''));
    setFieldError('number', '');
    syncCardSave();
  }

  function onCardBlur(e) {
    var t = e.target;
    if (!t || !t.hasAttribute) return;
    if (t.hasAttribute('data-pay-card-number')) {
      var digits = t.value.replace(/\D/g, '');
      if (digits && !luhnValid(digits)) setFieldError('number', CARD_FIELD_FALLBACK.number);
      return;
    }
    if (t.hasAttribute('data-pay-card-month') || t.hasAttribute('data-pay-card-year')) {
      var state = expiryState();
      if (state === 'expired') {
        setFieldError('exp_month', 'This card is expired.');
        setFieldError('exp_year', '');
      } else if (state === 'invalid') {
        setFieldError(t.hasAttribute('data-pay-card-month') ? 'exp_month' : 'exp_year', 'Enter a valid expiration date.');
      }
      return;
    }
    if (t.hasAttribute('data-pay-card-name')) {
      if (t.value && !nameOk()) setFieldError('name_on_card', 'Enter the name on the card (2–60 characters).');
      return;
    }
    if (t.hasAttribute('data-pay-card-zip')) {
      var cardCountry = billingCountry();
      if (cardCountry === 'CA' && zipIsValid(t.value, 'CA')) t.value = normalizeZip(t.value, 'CA');
    }
    var cardField = cardAddressFieldName(t);
    if (!cardField) return;
    var cardProblems = cardStreetZipProblems();
    if (t.value && cardProblems[cardField]) setFieldError(cardField, cardProblems[cardField]);
  }

  function cardAddressFieldName(node) {
    var names = ['address1', 'zip'];
    for (var i = 0; i < names.length; i++) {
      if (node.hasAttribute('data-pay-card-' + names[i])) return names[i];
    }
    return '';
  }

  function focusFirstFieldError() {
    for (var i = 0; i < CARD_FIELDS.length; i++) {
      var node = payEl('[data-pay-field-error="' + CARD_FIELDS[i] + '"]');
      if (node && !node.hidden) {
        var input = fieldInput(CARD_FIELDS[i]);
        if (input) input.focus();
        return;
      }
    }
  }

  function applyFieldErrors(errors) {
    var applied = 0;
    var extra = [];
    var known = {};
    if (errors && typeof errors === 'object') {
      Object.keys(errors).forEach(function (key) {
        var msgs = errors[key];
        var text = '';
        if (Array.isArray(msgs)) {
          text = msgs.filter(function (m) { return typeof m === 'string'; }).join(' ');
        } else if (typeof msgs === 'string') text = msgs;
        text = scrubCardText(text);
        if (CARD_FIELDS.indexOf(key) !== -1) {
          known[key] = true;
          if (!text) text = CARD_FIELD_FALLBACK[key];
          setFieldError(key, text);
          applied += 1;
        } else if (text) extra.push(text);
      });
    }
    CARD_FIELDS.forEach(function (field) {
      if (!known[field]) setFieldError(field, '');
    });
    if (extra.length) showAddError(extra.join(' '));
    else clearAddError();
    if (applied) focusFirstFieldError();
    return applied;
  }

  function publicCard(card) {
    return {
      token_id: card.token_id,
      brand: card.brand,
      last4: card.last4,
      exp_month: card.exp_month,
      exp_year: card.exp_year,
      expires: card.expires,
      is_default: card.is_default,
      name_on_card: card.name_on_card
    };
  }

  function focusSelectedCard() {
    var input = payEl('[data-pay-cards] input[type="radio"]:checked');
    if (input) input.focus();
    else focusCard();
  }

  function acceptSavedCard(card) {
    var saved = publicCard(card);
    var token = String(saved.token_id || '');
    var next = [];
    var found = false;
    for (var i = 0; i < payCards.length; i++) {
      if (String(payCards[i].token_id) === token) {
        next.push({
          token_id: saved.token_id,
          brand: saved.brand || payCards[i].brand,
          last4: saved.last4 || payCards[i].last4,
          exp_month: saved.exp_month || payCards[i].exp_month,
          exp_year: saved.exp_year || payCards[i].exp_year,
          expires: saved.expires || payCards[i].expires,
          is_default: saved.is_default,
          name_on_card: saved.name_on_card || payCards[i].name_on_card
        });
        found = true;
      } else {
        next.push(payCards[i]);
      }
    }
    if (!found && token) next.push(saved);
    var quote = payQuote;
    renderCards(next, token);
    if (quote) {
      payQuote = quote;
      paintSummary(payQuote);
    }
    showFlow();
    if (!payQuote && !quoteBusy && selectedIds().length) fetchQuoteNow();
    else syncPayButton();
    focusSelectedCard();
  }

  function retryAfterSeconds(res) {
    var raw = res && res.retryAfter ? String(res.retryAfter).trim() : '';
    if (/^\d+$/.test(raw)) return parseInt(raw, 10);
    if (raw) {
      var when = Date.parse(raw);
      if (!isNaN(when)) {
        var secs = Math.round((when - Date.now()) / 1000);
        return secs > 0 ? secs : 0;
      }
    }
    return 60;
  }

  function scheduleCooldownTick() {
    clearTimeout(cardCooldownTimer);
    var left = cooldownRemaining();
    if (left <= 0) {
      cardCooldownUntil = 0;
      cardCooldownMessage = '';
      clearAddError();
      syncCardSave();
      return;
    }
    var base = scrubCardText(cardCooldownMessage || 'Too many attempts.');
    showAddError((base ? base + ' ' : '') + 'Try again in ' + left + ' seconds.');
    syncCardSave();
    cardCooldownTimer = setTimeout(scheduleCooldownTick, 1000);
  }

  function armCooldown(seconds, message) {
    var secs = seconds > 0 ? seconds : 1;
    cardCooldownUntil = Date.now() + secs * 1000;
    cardCooldownMessage = scrubCardText(message || 'Too many attempts.');
    scheduleCooldownTick();
  }

  function blockCardAdd(message, disablePay) {
    cardBlocked = true;
    cardBlockMessage = message || 'Online payment is not available.';
    if (disablePay) {
      invoicePayEnabled = false;
      paintPayChrome();
      hidePayCta();
    }
    showAddError(cardBlockMessage);
    syncCardSave();
  }

  function handleCardResponse(res) {
    setCardBusy(false);
    var body = res.body || {};
    var code = payErrorCode(body);
    if ((body.status === 'saved' || body.status === 'exists') && body.card && body.card.token_id) {
      acceptSavedCard(body.card);
      return;
    }
    if (code === 'validation_failed') {
      var applied = applyFieldErrors(body.errors);
      if (!applied) showAddError(safePayMessage(body, 'Check the card details and try again.'));
      syncCardSave();
      return;
    }
    if (code === 'billing_update_failed' || code === 'card_not_applied') {
      var updateFallback = code === 'billing_update_failed'
        ? 'We could not update the billing address on file. Please contact AR.'
        : PAY_GENERIC;
      showResult('error', 'Payment not completed', [safePayMessage(body, updateFallback)], { again: true });
      return;
    }
    if (code === 'billing_state_missing' || code === 'billing_invalid') {
      var cardFallback = code === 'billing_invalid' ? 'Enter a valid billing address.' : 'Please contact AR.';
      if (body.on_file && typeof body.on_file === 'object') {
        if (body.on_file.address1 != null) setInputValue('[data-pay-card-address1]', body.on_file.address1);
        if (body.on_file.zip != null) setInputValue('[data-pay-card-zip]', body.on_file.zip);
      }
      showAddError(safePayMessage(body, cardFallback));
      syncCardSave();
      var cardStreet = payEl('[data-pay-card-address1]');
      if (cardStreet && cardStreet.focus) cardStreet.focus();
      return;
    }
    if (code === 'card_invalid' || code === 'card_expired' || code === 'bad_request') {
      var fallback = code === 'card_expired' ? 'This card is expired.' : 'This card could not be saved. Check the details and try again.';
      showAddError(safePayMessage(body, fallback));
      syncCardSave();
      return;
    }
    if (code === 'too_many_attempts') {
      armCooldown(retryAfterSeconds(res), payMessage(body, 'Too many attempts.'));
      return;
    }
    if (code === 'pay_disabled' || code === 'customer_not_allowed' || res.status === 403) {
      blockCardAdd(
        safePayMessage(body, 'Online payment is not available.'),
        code === 'pay_disabled' || (res.status === 403 && code !== 'customer_not_allowed')
      );
      return;
    }
    if (code === 'restlet_unavailable') {
      showAddError(safePayMessage(body, PAY_GENERIC));
      syncCardSave();
      return;
    }
    showAddError(safePayMessage(body, PAY_GENERIC));
    syncCardSave();
  }

  function setCardBusy(on) {
    cardBusy = !!on;
    var add = payEl('[data-pay-add]');
    if (add) {
      Array.prototype.forEach.call(add.querySelectorAll('input, select, button'), function (node) {
        if (node.hasAttribute('data-pay-card-save')) return;
        node.disabled = cardBusy;
      });
    }
    syncCloseLocked();
    syncCardSave();
  }

  function saveCard() {
    if (cardBusy || cardBlocked || cooldownRemaining() > 0 || !cardFormReady()) return;
    var numberEl = fieldInput('number');
    var monthEl = fieldInput('exp_month');
    var yearEl = fieldInput('exp_year');
    var nameEl = fieldInput('name_on_card');
    var zipEl = fieldInput('zip');
    var streetEl = fieldInput('address1');
    if (!numberEl || !monthEl || !yearEl || !nameEl || !zipEl || !streetEl) return;
    var entered = readCardStreetZip();
    var cardBody = {
      number: numberEl.value,
      exp_month: parseInt(monthEl.value, 10),
      exp_year: parseInt(yearEl.value, 10),
      name_on_card: nameEl.value.trim(),
      address1: String(entered.address1 || '').trim(),
      zip: normalizeZip(entered.zip, billingCountry())
    };
    var payload = JSON.stringify(cardBody);
    clearAddError();
    setCardBusy(true);
    var session = paySession;
    proxyFetch('/invoices/pay/cards', {
      method: 'POST',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: payload
    }).then(function (res) {
      payload = '';
      if (session !== paySession || !cardStepOpen()) {
        setCardBusy(false);
        return;
      }
      handleCardResponse(res);
    }).catch(function () {
      payload = '';
      setCardBusy(false);
      if (cardStepOpen()) showAddError(PAY_GENERIC);
    });
  }

  function bindPayModal() {
    payRoot = el('[data-pay-modal]');
    if (!payRoot) return;
    initAddressWidgets();
    var header = el('[data-pay-invoices]');
    if (header) header.addEventListener('click', function () { openPayModal(null); });
    Array.prototype.forEach.call(payRoot.querySelectorAll('[data-pay-close]'), function (node) {
      node.addEventListener('click', function () { closePayModal(); });
    });
    var all = payEl('[data-pay-select-all]');
    if (all) all.addEventListener('change', function () {
      var on = all.checked;
      var list = payEl('[data-pay-invoices-list]');
      if (!list) return;
      Array.prototype.forEach.call(list.querySelectorAll('input[type="checkbox"]'), function (box) {
        box.checked = on;
      });
      onSelectionChange();
    });
    var list = payEl('[data-pay-invoices-list]');
    if (list) list.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'checkbox') return;
      onSelectionChange();
    });
    var cards = payEl('[data-pay-cards]');
    if (cards) cards.addEventListener('change', onCardChange);
    var submit = payEl('[data-pay-submit]');
    if (submit) submit.addEventListener('click', function (e) {
      e.preventDefault();
      submitPay();
    });
    var retry = payEl('[data-pay-retry]');
    if (retry) retry.addEventListener('click', function () { showFlow(); focusCard(); });
    var again = payEl('[data-pay-again]');
    if (again) again.addEventListener('click', function () { showFlow(); focusPayDialog(); });
    var done = payEl('[data-pay-done]');
    if (done) done.addEventListener('click', closePayModal);
    var addOpen = payEl('[data-pay-add-open]');
    if (addOpen) addOpen.addEventListener('click', function () {
      if (payBusy || cardBusy) return;
      openAddCard();
    });
    var addBack = payEl('[data-pay-add-back]');
    if (addBack) addBack.addEventListener('click', function () {
      if (cardBusy) return;
      showFlow();
      focusPayDialog();
    });
    var addSave = payEl('[data-pay-card-save]');
    if (addSave) addSave.addEventListener('click', function (e) {
      e.preventDefault();
      saveCard();
    });
    var addPanel = payEl('[data-pay-add]');
    if (addPanel) {
      addPanel.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || !t.hasAttribute) return;
        if (t.hasAttribute('data-pay-card-number')) { onCardNumberInput(); return; }
        if (t.hasAttribute('data-pay-card-month')) {
          keepDigits(t, 2);
          setFieldError('exp_month', '');
          syncCardSave();
          return;
        }
        if (t.hasAttribute('data-pay-card-year')) {
          keepDigits(t, 4);
          setFieldError('exp_year', '');
          syncCardSave();
          return;
        }
        if (t.hasAttribute('data-pay-card-name')) {
          setFieldError('name_on_card', '');
          syncCardSave();
          return;
        }
        var cardField = cardAddressFieldName(t);
        if (cardField) {
          setFieldError(cardField, '');
          syncCardSave();
        }
      });
      addPanel.addEventListener('change', function () { syncCardSave(); });
      addPanel.addEventListener('blur', onCardBlur, true);
      addPanel.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || !e.target || e.target.tagName !== 'INPUT') return;
        e.preventDefault();
        saveCard();
      });
    }
    var billing = payEl('[data-pay-billing]');
    if (billing) {
      billing.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-pay-billing-avs-open]') : null;
        if (!btn) return;
        e.preventDefault();
        toggleAvs();
      });
      billing.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.hasAttribute) return;
        if (!t.hasAttribute('data-pay-bill-state')) return;
        setBillingFieldError('state', '');
        showBillingError('');
        noteBillingEdited();
        paintBilling();
        syncPayButton();
      });
      billing.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || !t.hasAttribute) return;
        if (t.hasAttribute('data-pay-avs-address1') || t.hasAttribute('data-pay-avs-zip')) {
          setAvsFieldError(t.hasAttribute('data-pay-avs-zip') ? 'zip' : 'address1', '');
          showBillingError('');
          noteBillingEdited();
          syncPayButton();
          return;
        }
        var field = billFieldName(t);
        if (!field) return;
        setBillingFieldError(field, '');
        showBillingError('');
        noteBillingEdited();
        paintBilling();
        syncPayButton();
      });
      billing.addEventListener('blur', onBillBlur, true);
    }
    document.addEventListener('keydown', onPayKeydown, true);
  }

  /* -------------------------------------------------------------- carousels */

  Array.prototype.forEach.call(app.querySelectorAll('[data-scroll]'), function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('.dash-row');
      var track = row && row.querySelector('[data-track]');
      if (!track) return;
      var card = track.querySelector('.dash-card');
      var step = card ? card.offsetWidth + 16 : track.clientWidth;
      track.scrollBy({ left: btn.dataset.scroll === 'next' ? step : -step, behavior: 'smooth' });
    });
  });

  bindPayModal();
  loadContext();
  loadOpenQuotes();
  loadRecentOrders();
  loadOpenInvoices();
})();
